,
<template>
  <!-- <div class="container mx-auto lg:py-8 md:py-12 py-8 lg:px-12 md:px-8 px-5">
    <h3
      class="fsize32 sm-fsize20 font-semibold text-center lg:pb-8 md:pb-8 pb-6"
    >
      Documents
    </h3>
    <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
      <div
        class="rounded-lg cursor-pointer relative h-72 overflow-hidden"
        v-for="(item, index) in regulationspolicy.data"
        :key="index"
        @click="ClickOpen(item)"
      >
        <div class="gradient">
          <img
            :src="`${$imageURL}/${item.image}`"
            class="w-full object-cover h-72 flex"
            alt="medical condition "
          />
        </div>
        <div class="absolute bottom-0 z-50 left-0 pb-3 w-full lg:px-4 px-2">
          <h5 class="fsize18 font-medium text-white">{{ item.title }}</h5>
          <p class="ellipsis-3 mt-1 leada fsize14 text-white w-11/12">
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
  </div> -->
  <div class="lg:py-16 lg:px-24 md:px-16 px-4">
    <h4 class="text-dark lg:text-4xl md:text-3xl text-2xl mt-2 font-semibold">
      Documents
    </h4>
    <div
      class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 lg:mt-8 md:mt-6 mt-5"
    >
      <div
        class="border rounded-xl overflow-hidden cursor-pointer"
        v-for="(item, index) in regulationspolicy.data"
        :key="index"
      >
        <img
          :src="`${$imageURL}/${item.image}`"
          class="h-52 w-full object-cover cursor-pointer"
        />

        <div class="lg:p-4 md:p-4 p-4">
          <h4
            class="text-dark fsize20 leading-6 mt-6 font-semibold lineclamp-1"
          >
            {{ item.title }}
          </h4>

          <p class="mt-1 fsize14 text-dark font-semibold">
            Date: <span class="font-normal">{{ getDate(item.createdAt) }}</span>
          </p>

          <!-- <div>
              <p
                class="mt-1 fsize14 text-dark font-semibold"
                v-if="i.hasOwnProperty('fileType') && i.fileType == 'Url'"
              >
                <span class="font-normal">{{ i.url }}</span>
              </p>
            </div> -->

          <div>
            <!-- <el-dialog
                :visible.sync="readMoreVisible"
                width="30%"
                :before-close="handleClose"
              >
                <span class="break-normal">{{ readMoreData }}</span>
              </el-dialog> -->
            <div class="h-12">
              <p
                class="mt-1 fsize14 text-dark cursor-pointer font-normal lineclamp-2"
              >
                {{ item.description }}
                <!-- <span
                  v-if="i.description.length >= 40"
                  @click="handleReadMore(true, i)"
                  class="text-primary"
                  >read more</span
                > -->
              </p>
            </div>
          </div>

          <div class="flex items-center gap-2 justify-content-center">
            <b-button
              class="mt-2 border-2"
              variant="primary"
              @click="ClickOpen(item)"
              >View</b-button
            >
            <!-- <b-button
                class="mt-2 border-2"
                variant="primary"
                @click="downloadPDF(i)"
                v-else-if="
                  i.hasOwnProperty('fileType') && i.fileType == 'Document'
                "
                >Download</b-button
              > -->
            <!-- <b-button
                v-else
                class="mt-2 border-2"
                variant="primary"
                @click="openFile(i)"
                >Read More</b-button
              > -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import moment from "moment";
import { mapState } from "vuex";

export default {
  components: {},
  data() {
    return {
      imgUrl: "",
    };
  },

  methods: {
    // ClickOpen(file) {
    //   const docOne = `https://nexuscluster.blob.core.windows.net/server01/${file}`;
    //   window.open(docOne, "_blank");
    // },
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    ClickOpen(item) {
      if (item.file && item.file) {
        const pdfUrl = `https://nimbus-server-01.brained.in/nimbus-server-01/${item.file}`;
        window.open(pdfUrl, "_blank");
      } else if (item.link) {
        window.open(item.link, "_blank");
      } else {
        console.warn("No valid document or link available.");
      }
    },
  },
  computed: {
    ...mapState("regulationPolicy", {
      regulationspolicy: "regulationspolicy",
    }),
  },

  async mounted() {
    await this.$store.dispatch("regulationPolicy/getRegulations");
    console.log("regulationspolicy", this.regulationspolicy);
  },
};
</script>

<style>
.ql-size-huge {
  font-size: 2.5em;
}

.ql-size-large {
  font-size: 1.5em;
}

.ql-size-small {
  font-size: 0.75em;
}

.heading-style > h1 {
  font-size: 2.5em;
}

.heading-style > h2 {
  font-size: 1.8em;
}

.heading-style > h3 {
  font-size: 1.5em;
}

.heading-style > h4 {
  font-size: 1.15em;
}

.heading-style > h5 {
  font-size: 1em;
}

.heading-style > h6 {
  font-size: 0.8em;
}
</style>
